import { Box } from '@chakra-ui/react';
import { useEffect } from 'react';

import Alert from 'UiKit/alert';

import Head from 'View/role/section/head';
import Filter from 'View/role/section/filter';
import Table from 'View/role/section/table';
import { useRoleState } from 'View/role/state';
import RoleProvider from 'View/role/state';

import styles from './styles.module.css';

const Role = () => {
  const { state, resetState } = useRoleState();

  useEffect(() => resetState(), /* eslint-disable */ []);

  return (
    <Box className={styles['role__container']}>
      <Head />
      <Filter />
      <Alert {...state?.alertProps} />
      <Table />
    </Box>
  );
};

const RoleContainer = () => <RoleProvider children={<Role />} />;

export default RoleContainer;
